module.exports = __webpack_public_path__ + "static/media/stephanie.ab6a9ba6.jpg";